var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { LayoutField, FieldLabel, FieldInput } from "../";

var GeocoderInput = (_temp2 = _class = function (_Component) {
    _inherits(GeocoderInput, _Component);

    function GeocoderInput() {
        var _temp, _this, _ret;

        _classCallCheck(this, GeocoderInput);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onChangeZoom = function (name) {

            return function (value) {

                if (value > 20) {
                    return false;
                }

                if (_this.props.onChange) {
                    _this.props.onChange(_extends({}, _this.props, {
                        source: "input",
                        zoom: parseFloat(value)
                    }));
                }
            };
        }, _this.onChangeCenter = function (name) {

            return function (value) {

                if (_this.props.onChange) {
                    var _extends2;

                    _this.props.onChange(_extends({}, _this.props, {
                        source: "input",
                        center: _extends({}, _this.props.center, (_extends2 = {}, _extends2[name] = parseFloat(value), _extends2))
                    }));
                }
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    GeocoderInput.prototype.render = function render() {
        var _props = this.props,
            center = _props.center,
            zoom = _props.zoom,
            placeId = _props.placeId;


        return React.createElement(
            "div",
            { className: "admin-geocoder__input" },
            React.createElement(
                "div",
                { className: "admin-geocoder__input  input--lat" },
                React.createElement(FieldLabel, { label: "PlaceId" }),
                React.createElement(FieldInput, { value: placeId, readonly: true })
            ),
            React.createElement(
                "div",
                { className: "admin-geocoder__input  input--lat" },
                React.createElement(FieldLabel, { label: "Latitude" }),
                React.createElement(FieldInput, { value: center.lat, onChange: this.onChangeCenter("lat") })
            ),
            React.createElement(
                "div",
                { className: "admin-geocoder__input  input--lng" },
                React.createElement(FieldLabel, { label: "Longitude" }),
                React.createElement(FieldInput, { value: center.lng, onChange: this.onChangeCenter("lng") })
            ),
            React.createElement(
                "div",
                { className: "admin-geocoder__input  input--zoom" },
                React.createElement(FieldLabel, { label: "Zoom" }),
                React.createElement(FieldInput, { value: zoom, min: "1", max: "20", onChange: this.onChangeZoom("zoom") })
            )
        );
    };

    return GeocoderInput;
}(Component), _class.defaultProps = {
    center: {
        lat: "",
        lng: ""
    },
    zoom: ""
}, _temp2);


export default GeocoderInput;